export const FINANCING_ENDING_BULK_ACTION_CODE = 'sendFinancingEndingEmail';
